/** Nur ansehen (Bestellungen, Verträge, Projekte): Leser und Finance */
export const isViewer = (role) => role === 'reader' || role === 'finance';
/** Seiten (Menüpunkte), die für Personen mit Rolle „lesend“ einzeln freigeschaltet werden. Start und Hilfe sieht jeder. */
export const SECTIONS = ['orders', 'contracts', 'projects', 'invoicing', 'forecast', 'issues'];
/**
 * Welche Seiten darf die Person sehen? Einschränkbar ist nur die Rolle „lesend“ ohne Delivery Head;
 * sections = null heißt: alle.
 */
export function allowedSections(u) {
    if (u.role !== 'reader' || u.deliveryHead || !u.sections)
        return [...SECTIONS];
    return SECTIONS.filter((s) => u.sections.includes(s));
}
export const ORDER_STATUS_LABEL = {
    warranty: 'Gewährleistung',
    overdrawn: 'Überzogen',
    settled: 'Abgerechnet',
    nearlyUsed: 'Fast verbraucht',
    unbilled: 'Ohne Rechnung',
    active: 'Aktiv',
};
/** Semantische Farbe je Status (Fiori-Logik: positiv, kritisch, negativ, Information, neutral). */
export const ORDER_STATUS_TONE = {
    warranty: 'neu',
    overdrawn: 'neg',
    settled: 'pos',
    nearlyUsed: 'crit',
    unbilled: 'info',
    active: 'neu',
};
//# sourceMappingURL=types.js.map